import { useMemo } from "react";
import { analisar, type No } from "../lib/textoRico";

// O renderizador da marcação do conteúdo — nós viram ELEMENTOS.
//
// Não existe `dangerouslySetInnerHTML` nesta árvore, e a ausência é a peça de
// segurança: o texto vem de uma coluna que o admin edita, e um dia pode vir de uma
// carga ou da mão de alguém no SQL editor. Enquanto o caminho for
// texto → nós → elementos, `<script>` no conteúdo é só texto com sinais de menor.
//
// O `href` sai de `urlSegura` (http e https, nada mais), aplicada no analisador.
// É a mesma disciplina de `profiles.redes`, que guarda o handle e monta a URL a
// partir de um prefixo fixo.

/** Um trecho com as marcas dele. As marcas se acumulam, então os elementos aninham. */
function Trecho({ no }: { no: No }) {
  let conteudo = <>{no.texto}</>;

  // `<mark>` é o elemento certo para "destaque de leitura", e o `bg-alerta-fundo`
  // é token — troca com o tema. As cinco cores cravadas do Bubble não trocavam, e
  // amarelo escrito para fundo branco fica ilegível no escuro.
  if (no.marcado) {
    conteudo = <mark className="rounded bg-alerta-fundo px-0.5 text-alerta-tinta">{conteudo}</mark>;
  }
  if (no.sublinhado) conteudo = <u className="underline decoration-1 underline-offset-2">{conteudo}</u>;
  if (no.negrito) conteudo = <strong className="font-semibold text-titulo">{conteudo}</strong>;

  if (no.url) {
    return (
      <a
        href={no.url}
        target="_blank"
        // `noreferrer` junto com `noopener`: é conteúdo com 43 links para fora, e
        // `window.opener` na aba de destino é o que a Fase 4 já tirou das portas.
        rel="noopener noreferrer"
        className="font-semibold text-link underline decoration-link/40 underline-offset-2 hover:decoration-link"
      >
        {conteudo}
      </a>
    );
  }
  return conteudo;
}

export default function TextoRico({ texto }: { texto: string }) {
  const nos = useMemo(() => analisar(texto), [texto]);
  return (
    <>
      {nos.map((no, i) => (
        <Trecho key={i} no={no} />
      ))}
    </>
  );
}
